import * as t from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* Base Catalog Collection Builder Actions                                                        */
/*------------------------------------------------------------------------------------------------*/
export const changeCurrentFields = (currentFields /*: [] */) => ({
  type: t.CHANGE_CURRENT_FIELDS,
  currentFields,
});

export const resetCollectionBuilder = () => ({ type: t.RESET_COLLECTION_BUILDER });

/*------------------------------------------------------------------------------------------------*/
/* Fetch Catalog Collection Actions                                                               */
/*------------------------------------------------------------------------------------------------*/
export const fetchCollection = (id /*: number */) => ({
  type: t.FETCH_COLLECTION,
  id,
  isFetchingCollection: true,
});

export const fetchCollectionError = ({ collectionNotFound, ...error }) => ({
  type: t.FETCH_COLLECTION_ERROR,
  error,
  collectionNotFound,
  isFetchingCollection: false,
});

export const fetchCollectionResponse = (response) => {
  const { catalogName, description, name } = response;
  return {
    type: t.FETCH_COLLECTION_RESPONSE,
    catalog: catalogName,
    description,
    isFetchingCollection: false,
    name,
  };
};

/*------------------------------------------------------------------------------------------------*/
/* Change Catalog Collection Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const changeCatalog = (catalog /*: string */, fetchFieldTypes /*: boolean */) => ({
  type: t.CHANGE_CATALOG,
  catalog,
  fetchFieldTypes,
});

export const changeCollectionDescription = (description /*: string */) => ({
  type: t.CHANGE_COLLECTION_DESCRIPTION,
  collectionHasChanged: true,
  description,
});

export const changeCollectionDetails = ({ name, description, catalog }) => ({
  type: t.CHANGE_COLLECTION_DETAILS,
  name,
  description,
  catalog,
});

export const changeCollectionName = (name) => ({
  type: t.CHANGE_COLLECTION_NAME,
  collectionHasChanged: true,
  name,
});

/*------------------------------------------------------------------------------------------------*/
/* Create Catalog Collection Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const createCollection = () => ({
  type: t.CREATE_COLLECTION,
  isSaving: true,
});

export const createCollectionError = (error) => ({
  type: t.CREATE_COLLECTION_ERROR,
  isSaving: false,
  error,
});

export const createCollectionResponse = (id /*: number */) => ({
  type: t.CREATE_COLLECTION_RESPONSE,
  collectionHasChanged: false,
  isSaving: false,
  id,
});

/*------------------------------------------------------------------------------------------------*/
/* Update Catalog Collection Actions                                                              */
/*------------------------------------------------------------------------------------------------*/
export const updateCollection = (id /*: number */, selectedCollection /*: {} */, callback) => ({
  type: t.UPDATE_COLLECTION,
  isSaving: true,
  id,
  selectedCollection,
  callback,
});

export const updateCollectionError = (error) => ({
  type: t.UPDATE_COLLECTION_ERROR,
  isSaving: false,
  error,
});

export const updateCollectionResponse = (id /*: number */) => ({
  type: t.UPDATE_COLLECTION_RESPONSE,
  collectionHasChanged: false,
  isSaving: false,
  id,
});

/*------------------------------------------------------------------------------------------------*/
/* Preview Catalog Collection Actions                                                             */
/*------------------------------------------------------------------------------------------------*/
export const previewCollection = (
  userIdentifier /*: string */,
  isEmail /*: boolean */,
  isExistingCollection /*: boolean */,
  canSave /*: boolean */,
) => ({
  type: t.PREVIEW_COLLECTION,
  isLoadingPreview: true,
  isExistingCollection,
  userIdentifier,
  isEmail,
  canSave,
});

export const previewCollectionError = (error) => ({
  type: t.PREVIEW_COLLECTION_ERROR,
  isLoadingPreview: false,
  error,
});

export const previewCollectionResponse = (previewData) => ({
  type: t.PREVIEW_COLLECTION_RESPONSE,
  isLoadingPreview: false,
  didPreviewData: true,
  previewData,
});

/*------------------------------------------------------------------------------------------------*/
/* View Field Mappings                                                                    */
/*------------------------------------------------------------------------------------------------*/

export const fetchFieldMappingsRequest = () => ({
  type: t.FETCH_FIELD_MAPPING_REQUEST,
});

export const fetchFieldMappingsResponse = (fieldMappings /*: [] */) => ({
  type: t.FETCH_FIELD_MAPPING_RESPONSE,
  fieldMappings,
});

export const fetchFieldMappingsError = (error) => ({
  type: t.FETCH_FIELD_MAPPING_ERROR,
  error,
});
